import { Component, Input, Output, EventEmitter, ViewEncapsulation, HostListener, AfterViewInit } from '@angular/core';

import { ModalService } from 'services';
import { ModalOptions, Size, Backdrop, Position } from '../types';
import { FcpModalService, ModalSizes } from 'fc-ui-components';
import { MediaBreakpoint } from '../../../../components/responsive-wrapper/constants';
import { DisplayMode } from 'app/b2b-order/components/order/single-store-modal/single-store-modal.component';

@Component({
    selector: 'fc-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConfirmDialogComponent implements AfterViewInit {
    @Input() modalId: string;
    @Input() title: string;
    @Input() confirmationQuestion: string;
    @Input() accept = 'TEXT_OK';
    @Input() cancel = 'TEXT_CANCEL';
    @Input() options: ModalOptions = {
        size: Size.Md,
        backdrop: Backdrop.Static,
        position: Position.Center,
        showCancelButton: true
    };
    @Input() useFcpModal = false;
    @Output() onReject = new EventEmitter<void>();
    @Output() onAccept = new EventEmitter<void>();
    public displayMode: DisplayMode = DisplayMode.Desktop;

    constructor(
        private modalService: ModalService,
        private fcpModalService: FcpModalService
    ) {}

    @HostListener('window:resize', ['$event'])
    onResize(event: { target: { innerWidth: number } }) {
        this.setDisplayMode(event.target.innerWidth);
    }

    ngAfterViewInit() {
        this.setDisplayMode(window.innerWidth);
    }

    public close() {
        if (this.useFcpModal) {
            this.fcpModalService.close(this.modalId);
        } else {
            this.modalService.close(this.modalId);
        }
    }

    private setDisplayMode(width: number) {
        if (width < MediaBreakpoint.Desktop) this.displayMode = DisplayMode.Mobile;
        else this.displayMode = DisplayMode.Desktop;
    }

    protected readonly DisplayMode = DisplayMode;
    protected readonly ModalSizes = ModalSizes;
}
